// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3vnuO","footer":"ReportModalFilter_footer__3Z44V"};